import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'UTCseconds'
})
export class UTCsecondsPipe implements PipeTransform {
    transform(value?: any, args?: any): any {
        var UTCseconds = Math.floor((new Date()).getTime());
        // console.log(UTCseconds);
        return UTCseconds;
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/utcSeconds.pipe.ts